/* global google */

(function() {
  "use strict";

  angular
    .module("app")
    .controller("RiskRankingMapController", [
      "$scope",
      "$http",
      "$timeout",
      "$location",
      "$attrs",
      "NgMap",
      "LoadingService",
      RiskRankingMapController,
    ]);

  function RiskRankingMapController(
    $scope,
    $http,
    $timeout,
    $location,
    $attrs,
    NgMap,
    LoadingService,
  ) {
    /*
            Helper functions from the old site for making shape data into a format Google Maps likes.
            Haven't touched these, just ported from the original code.
        */

    var regExes = {
      typeStr: /^\s*(\w+)\s*\(\s*(.*)\s*\)\s*$/,
      parenComma: /\)\s*,\s*\(/,
      doubleParenComma: /\)\s*\)\s*,\s*\(\s*\(/,
      trimParens: /^\s*\(?(.*?)\)?\s*$/,
    };

    // Helper function to determine the pixel location of a map lat/long
    // Used for Google Maps events that don't pass the browser mouse event data (x/y coords)
    $scope.latLng2Point = function(latLng, map) {
      var topRight = map
        .getProjection()
        .fromLatLngToPoint(map.getBounds().getNorthEast());
      var bottomLeft = map
        .getProjection()
        .fromLatLngToPoint(map.getBounds().getSouthWest());
      var scale = Math.pow(2, map.getZoom());
      var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
      return new google.maps.Point(
        (worldPoint.x - bottomLeft.x) * scale,
        (worldPoint.y - topRight.y) * scale,
      );
    };
		
    if (!google.maps.Polygon.prototype.getBounds) {
      google.maps.Polygon.prototype.getBounds = function () {
        var bounds = new google.maps.LatLngBounds();
        this.getPaths().forEach(function (element, index) {
          bounds.extend(element);
        });
        return bounds;
      };
    }

    // Per spec, legend colors are hard-coded, not provided by Datacenter
    $scope.legend = {
      colors: ["#0b7ace", "#3895cb", "#6fb6cc", "#97cdd0", "#c4e4df"],
    };

    $scope.mapHoverBox = {
      posLeft: 0,
      posTop: 0,
      hoveredCommunity: {},
    };

    $scope.doCommunityGroupToggle = function(groupName) {
      $scope.state.selectedCommunities.toggleCommunitiesByGroup(groupName);

      // Tracks when a user clicks on a community group checkbox button on the "Risk Ranking" page
      dataLayer.push({
        event: "Community Clicks",
        eventCategory: "Interactive Clicks",
        eventAction: "Community Click|" + groupName,
        eventLabel: window.location.pathname,
      });
    };

    $scope.doCommunityToggle = function(communityId) {
      $scope.state.selectedCommunities.toggleCommunity(communityId);

      // Tracks when a user clicks on a community checkbox button on the "Risk Ranking" page
      var communityName = $scope.state.communitiesById[communityId].name;
      dataLayer.push({
        event: "Community Clicks",
        eventCategory: "Interactive Clicks",
        eventAction: "Community Click|" + communityName,
        eventLabel: window.location.pathname,
      });
    };

    // Boundary overlay radios
    var overlaysString = $location.search().overlays;
    if (overlaysString) {
      // Select overlays based on url param
      $scope.overlayIds = overlaysString;
      var buttonValue = (overlaysString instanceof Array && overlaysString.length > 0)
        ? overlaysString[0]
        : overlaysString;
      $('.boundary-radio-hidden[value="' + buttonValue + '"]')
        .prop("checked", true);
    }

    $(".boundary-radio-hidden, .boundary-radio-hidden::before, .boundary-overlay-list label").click(function (e) {
      $(".boundary-radio-hidden").each(function (_index, radio) {
        $(radio).prop("checked", null);
      });

      var $hiddenRadio = $(".boundary-radio-hidden", $(e.target).parents("li"));
      $hiddenRadio.prop("checked", true);

      var radioVal = $hiddenRadio.val();
      var overlayVals = radioVal ? [radioVal, radioVal + "_label"] : null;
      $scope.overlayIds = overlayVals;

      // Update url param with user's selected overlay
      $location.search("overlays", overlayVals);

      $scope.rrMap.renderOverlays();

      e.preventDefault();
      e.stopPropagation();
    });

    // Show/hide the legend when the "+/-" button is clicked
    $(".icon-map-overlay-control").on("click", function (e) {
      e.preventDefault();

      var $content = $(".map-overlay-content", $(e.target).parents(".map-overlay-block"));
      if (self.isClosed) {
        // Show it
        $content.parent().removeClass("closed");
        $content.slideDown();
        self.isClosed = false;
      }
      else {
        // Hide it
        $content.slideUp(400, function () {
          $content.parent().addClass("closed");
        });
        self.isClosed = true;
      }
    });

    $scope.rrMap = {
      // Only need to render the full map once
      hasRendered: false,

      // Used to determine functionality for live site vs. "Download Image" mode
      mapOptions: {
        zoomControl: $scope.currentURL.search().cap ? false : true,
        scrollWheel: false,
      },

      // `forceInactive` is used to force a community shape back to its non-highlighted default state,
      // specifically when a user is hovering on a community and clicks to deselect it. Without
      // forcing a non-highlighted state, the code would detect the `mouseover` and highlight it
      styleShape: function(fips, forceInactive) {
        // It's possible this method will be called before the map is rendered
        // If so, just return out. We'll update the shape style eventually.
        // TODO - Feels like a race condition. What's causing this?
        if (!$scope.cShapes) {
          return false;
        }

        // Sugar
        var shape = $scope.cShapes[fips];
        var community = $scope.state.communitiesByFips[fips];

        // Set the shape's background color
        // First, make sure the shape that the user is interacting with is an actual community,
        // not a non-community placeholder shape on the map
        if (!community) {
          return; 
        }

        var determineShapeColorUsingLegend = true;

        var curCommunity = $scope.state.communitiesByFips[fips];
        var indicatorsForCurCommunity = curCommunity.indicators;
        var selectedIndicator = $scope.state.selectedIndicator;
        if (selectedIndicator) {
          var curIndicatorId = selectedIndicator.id;
          var curIndicatorForCurCommunity = indicatorsForCurCommunity[curIndicatorId];
          
          if (curIndicatorForCurCommunity) {
            var indicatorValueForCurLocation = curIndicatorForCurCommunity.value;
  
            // Try to determine the color for the shape by comparing its community's data value with the bounds from the legend
            var index = $scope.state.mapLegend.findIndex((legendItem) => {
              return (legendItem.lowDataValue <= indicatorValueForCurLocation && indicatorValueForCurLocation < legendItem.highDataValue); 
            });
  
            determineShapeColorUsingLegend = index >= 0;
          }
          else {
            determineShapeColorUsingLegend = false;
          }
        }
        else {
          determineShapeColorUsingLegend = false;
        }

        if (determineShapeColorUsingLegend) {
          $scope.cShapes[fips].fillColor = $scope.legend.colors[index];
        }
        else {
          if (selectedIndicator && selectedIndicator.id === $scope.state.selectedDomain.id) {
            $scope.cShapes[fips].fillColor = $scope.legend.colorByGroup[community.group];
          }
          else if ($scope.legend.colorByCommunity && $scope.legend.colorByCommunity[community.id]) {
            $scope.cShapes[fips].fillColor = $scope.legend.colorByCommunity[community.id];
          }
          else {
            $scope.cShapes[fips].fillColor = $scope.legend.colorByGroup[community.group];
          }
        }

        // Check if shape is hovered, but we're not forcing the default un-highlighted state
        if (
          !forceInactive &&
            ($scope.mapHoverBox.hoveredCommunity.id === community.id ||
              $scope.state.selectedCommunities.communityIsSelected(
                community.id,
              ))
        ) {
          shape.setOptions({
            strokeColor: "#dea003",
            strokeWeight: 3,
            zIndex: 99,
          });
        }
        else {
          shape.setOptions({
            strokeColor: "#fff",
            strokeWeight: 1,
            zIndex: 1,
          });
        }
      },
      actions: {
        mouseover: function(event, shape, map) {
          $scope.mapHoverBox.hoveredCommunity =
            $scope.state.communitiesByFips[shape.fips];

          $scope.mapHoverBox.communityRank = $scope.mapHoverBox.hoveredCommunity
            ? $scope.mapHoverBox.hoveredCommunity.rank
            : 0;

          // When hovering over a community, mark this flag as false so we don't also show the asset pop-out
          $scope.mapHoverBox.isAsset = false;

          if ($scope.mapHoverBox.hoveredCommunity) {
            var eventLoc = $scope.latLng2Point(event.latLng, $scope.map);

            $scope.mapHoverBox.posLeft = eventLoc.x + 25;
            $scope.mapHoverBox.posTop = eventLoc.y - 50;
          }

          $scope.$apply();
          $scope.rrMap.styleShape(shape.fips);
        },
        mouseout: function(event, shape, map) {
          // Reset the map hover box
          $scope.mapHoverBox.posLeft = null;
          $scope.mapHoverBox.posTop = null;
          $scope.mapHoverBox.communityRank = null;
          $scope.mapHoverBox.hoveredCommunity = {};
          $scope.$apply();

          $scope.rrMap.styleShape(shape.fips);
        },
        click: function(event, shape, map) {
          // Tracks when a user clicks on a community on a map on the "Risk Ranking" page
          var community = $scope.state.communitiesByFips[shape.fips];
          if (community) {
            dataLayer.push({
              event: "Map Clicks",
              eventCategory: "Interactive Clicks",
              eventAction: "Map Click|" + community.name,
              eventLabel: window.location.pathname,
            });
            $scope.state.selectedCommunities.toggleCommunity(community.id);
          }
          else {
            console.error("No community found for this shape:", shape);
						
            var latitude = event.latLng.lat();
            var longitude = event.latLng.lng();
            console.debug(latitude + ", " + longitude);
          }
        },
      },

      // This is wrapped in a function so we can hold off on generating the map until all the
      // community data we need has successfully loaded
      render: function() {
        if (!$scope.rrMap.hasRendered) {
          NgMap.getMap().then(function(map) {
            $scope.rrMap.labelEngine = new CCCLabelEngine(map);
            var shapesLoadingId = LoadingService.taskStart(
              $scope,
              "Loading Map Shapes",
            );

            $http({
              method: "GET",
              url:
                "/api/MapData/GetWktPolygons?locationTypeId=3&isSimplified=true",
              cache: true,
            }).then(
              function successCallback(response) {
                $scope.rrMap.hasRendered = true;

                $scope.cShapes = {};

                // Parse out the WKT text into google API Polygons
                for (var fips in response.data) {
                  var wktPolygon = response.data[fips];

                  var polygon = ccc.viz.map.util.MapUtil.wktToGooglePolygon(
                    wktPolygon,
                  );

                  polygon.setOptions({
                    fips: fips,
                  });

                  $scope.cShapes[fips] = polygon;

                  $scope.rrMap.styleShape(fips);

                  // Render the shape on the map itself
                  $scope.cShapes[fips].setMap(map);

                  google.maps.event.addListener(
                    $scope.cShapes[fips],
                    "mouseover",
                    function(event) {
                      $scope.rrMap.actions.mouseover(event, this, map);
                    },
                  );

                  google.maps.event.addListener(
                    $scope.cShapes[fips],
                    "mouseout",
                    function(event) {
                      $scope.rrMap.actions.mouseout(event, this, map);
                    },
                  );

                  google.maps.event.addListener(
                    $scope.cShapes[fips],
                    "click",
                    function(event) {
                      var latitude = event.latLng.lat();
                      var longitude = event.latLng.lng();
                      console.debug( latitude + ", " + longitude );

                      $scope.rrMap.actions.click(event, this, map);
                    },
                  );
                }

                LoadingService.taskEnd($scope, shapesLoadingId);

                $scope.rrMap.renderOverlays();

                if (!$attrs.assetMap) {
                  $timeout(function() {
                    // At this point, the map should be all done rendering
                    if ($scope.currentURL.search().cap) {
                      window.triggerScreenshot();
                    }
                  }, 750);
                }
              },
              function errorCallback(response) {
                console.warn("Couldn't load map shapes!");
              },
            );

            // Check URL params for default zoom level and center point
            if ($location.search().zoom) {
              map.setZoom(+$location.search().zoom);
            }

            if ($location.search().center) {
              var rawLatLng = $location.search().center.split(",");
              var latLng = {
                lat: +rawLatLng[0],
                lng: +rawLatLng[1],
              };
              map.setCenter(latLng);
            }

            // Update the URL params when a user zooms, or drags the map around
            google.maps.event.addListener(map, "zoom_changed", function() {
              $scope.$apply(function() {
                $location.search("zoom", map.getZoom());
              });
            });

            google.maps.event.addListener(map, "center_changed", function() {
              $scope.$apply(function() {
                $location.search(
                  "center",
                  map.getCenter().lat() + "," + map.getCenter().lng(),
                );
              });
            });
            google.maps.event.addListener(map, "idle", () => $scope.rrMap.renderLabels());

          }); // NgMap
        } // hasRendered
      }, // render()

      labelLoadingTaskDone: function(labelsLoadingId) {
        return () => {
          LoadingService.taskEnd($scope, labelsLoadingId);
        };
      },

      overlayColors: {
        "0": "#E7298A",
        "1": "#E7298A",
        "2": "#E7298A",
        "3": "#E7298A",
        "4": "#E7298A",
        "5": "#E7298A",
        "6": "#E7298A",
        "7": "#E7298A",
      },

      removeOverlays: function () {
        // Remove old shapes
        if ($scope.overlayShapes) {
          for (var index in $scope.overlayShapes) {
            var polygon = $scope.overlayShapes[index];
            if (polygon && polygon.setMap) {
              polygon.setMap(null);
            }
          }
        }
      },

      removeOverlayMarkers: function () {
        // Remove old markers
        if ($scope.overlayMarkers) {
          for (var index in $scope.overlayMarkers) {
            var marker = $scope.overlayMarkers[index];
            if (marker && marker.setMap) {
              marker.setMap(null);
            }
          }
        }
      },

      renderLabels: function() {
        // TO DO - Loading Service tasks for labels
        // var labelsLoadingId = LoadingService.taskStart($scope, "Loading Labels");
        $scope.rrMap.labelEngine.renderLabels($scope.overlayMarkers);//, null, $scope.rrMap.labelLoadingTaskDone(labelsLoadingId));
      },

      renderOverlays: function () {
        var overlaysLoadingId = LoadingService.taskStart($scope, "Loading District Overlays");

        $scope.rrMap.removeOverlays();
        $scope.rrMap.removeOverlayMarkers();

        const zipcodesOverlayTypeId = "4";
        var labelClasslist = "overlay-label overlay-label--hidden"; // Hide labels until we're ready, once LabelGun prunes the overlapping ones
        var overlayTypeIds = $scope.overlayIds;
        if (overlayTypeIds instanceof Array && overlayTypeIds.indexOf(zipcodesOverlayTypeId) >= 0) {						
          labelClasslist += " overlay-label--small"; // Use smaller font for zipcodes
        }

        // global
        var hardcodedPositions = hardcodedPositionsByOverlayTypeAndFips;
        NgMap.getMap().then(function (map) {
          $http({
            method: "GET",
            url: "/api/MapData/GetWktOverlayPolygons?overlays=" + $scope.overlayIds, //overlayTypesToRequest,
            cache: true,
          }).then(function successCallback(response) {
            // Remove references to the marker and shape objects as late as possible
            // Doing this too soon results in orphaned markers and shapes after zooming
            // This is because Google's setMap() is asynchronous
            // See $scope.rrMap.removeOverlays(), $scope.rrMap.removeOverlayMarkers()
            $scope.overlayShapes = [];
            $scope.overlayMarkers = [];

            // Parse out the WKT text into google API Polygons
            for (var key in response.data) {
              var tokens = key.split("|");
              var overlayType = tokens[0];
              var fips = tokens[1];
              var labelContent = tokens[2];

              var wktPolygon = response.data[key];

              var polygon = ccc.viz.map.util.MapUtil.wktToGooglePolygon(wktPolygon);

              polygon.setOptions({
                clickable: false,
                fips: fips,
                overlayType: overlayType,
                fillColor: "#ffffff",
                fillOpacity: 0.0,
                strokeColor: $scope.rrMap.overlayColors[overlayType],
                strokeOpacity: 0.9,
                strokeWeight: 1,
                zIndex: 100 + parseInt(overlayType),
              });

              // Render the shape on the map itself
              polygon.setMap(map);
              $scope.overlayShapes.push(polygon);

              // Add label marker for the polygon
              var noIcon = {
                // Workaround to have a label with no icon
                path: google.maps.SymbolPath.CIRCLE,
                scale: 0,
              };
							
              // account for label text itself
              var labelXOffset = 5 + fips.length * 4;
              var labelYOffset = 15;
              var labelAnchor = new google.maps.Point(labelXOffset, labelYOffset);
							
              // hardcoded positions
              var positions;
              if (hardcodedPositions && hardcodedPositions[overlayType]) {
                positions = hardcodedPositions[overlayType][fips];
              }
							
              if (!positions || !positions.length) {
                // Just need one label - position over geometric center
                var center = polygon.getBounds().getCenter();
                $scope.overlayMarkers.push(new MarkerWithLabel({
                  map: map,
                  position: center,
                  icon: noIcon,
                  labelContent: labelContent,
                  labelAnchor: labelAnchor,
                  labelClass: labelClasslist,
                }));
              }
              else {
                positions.forEach(position => {
                  // Hardcoded positions, and possibly multiple labels for gerrymandered/multipolygon locations
                  $scope.overlayMarkers.push(new MarkerWithLabel({
                    map: map,
                    position: new google.maps.LatLng(position[0], position[1]),//position,
                    icon: noIcon,
                    labelContent: labelContent,
                    labelAnchor: labelAnchor,
                    labelClass: labelClasslist,
                  }));								
                });
              }
            } // foreach key in response.data
            LoadingService.taskEnd($scope, overlaysLoadingId);

            $scope.rrMap.renderLabels();
          }); // $http.then()
        }); // renderOverlays()
      },
    }; // $scope.rrMap
  } // RiskRankingMapController
})();
